import { render, staticRenderFns } from "./board.vue?vue&type=template&id=3f90dcba&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"
import style0 from "./board.vue?vue&type=style&index=0&id=3f90dcba&prod&lang=css"
import style1 from "./board.vue?vue&type=style&index=1&id=3f90dcba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90dcba",
  null
  
)

export default component.exports